/* Adjustments loaded just before ar-theme.js. */
(function () {
  /* colour photos come from the photo attached to the variant in Shopify, not from the pictures bundled with the theme */
  var X = window.ARD && window.ARD.X;
  if (X) Object.keys(X).forEach(function (k) { if (X[k] && X[k].cs) delete X[k].cs; });
  /* the welcome pop-up waits 5 seconds (the theme script asks for 1.4) */
  var st = window.setTimeout;
  window.setTimeout = function (f, d) {
    if (d === 1400) { d = 5000; window.setTimeout = st; }
    return st.apply(window, [f, d].concat(Array.prototype.slice.call(arguments, 2)));
  };
})();
(function(){var D=window.ARD;if(!D)return;try{var a='Set of 4 (white)',b='Set of 4 (pink)',t=JSON.stringify(D);if(t.indexOf(a)<0)return;var N=JSON.parse(t.split(a).join(b));for(var k in N)D[k]=N[k];}catch(e){}})();
/* Option order. The theme script reasons as [size, colour]. In the admin the colour
   option can come first: this file, loaded just before ar-theme.js, puts the data and
   the product form back in that order, and keeps the colour choice shown first. */
(function () {
  var RE = /colou?r|design|style/i;
  function swapped(n) { return !!n && n.length === 2 && RE.test(n[0]) && !RE.test(n[1]); }
  function names(o) { return (o || []).map(function (x) { return typeof x === 'string' ? x : x.name; }); }
  function normP(P) {
    if (!P || P._n || !P.variants) return P;
    P._n = 1;
    if (swapped(names(P.options))) {
      P.options = [P.options[1], P.options[0]];
      P.variants.forEach(function (v) { if (!v.options || v.options.length !== 2) return; v.options = [v.options[1], v.options[0]]; var a = v.option1; v.option1 = v.option2; v.option2 = a; });
      P._sw = 1;
    }
    return P;
  }
  function normItem(i) { var o = i && i.options_with_values; if (o && swapped(names(o))) i.options_with_values = [o[1], o[0]]; }
  function fix(d) {
    if (!d || typeof d !== 'object') return d;
    if (d.variants) return normP(d);
    if (d.items) d.items.forEach(normItem); else normItem(d);
    return d;
  }

  /* data read later by the theme script: product .js and cart answers */
  var f = window.fetch;
  if (f) window.fetch = function (u) {
    var url = typeof u === 'string' ? u : (u && u.url) || '';
    var hit = /\/products\/[^/?#]+\.js(\?|$)/.test(url) || /\/cart(\/(add|change|update|clear))?\.js(\?|$)/.test(url);
    var p = f.apply(this, arguments);
    return hit ? p.then(function (r) { var j = r.json.bind(r); r.json = function () { return j().then(fix); }; return r; }) : p;
  };

  /* product page */
  var el = document.getElementById('arProduct'), form = document.getElementById('arBuy');
  if (!el || !form) return;
  var P; try { P = JSON.parse(el.textContent); } catch (e) { return; }
  if (!swapped(names(P.options))) return;
  var g = form.querySelectorAll('.ar-opt');
  if (g.length !== 2) return;
  var colour = g[0], size = g[1], cName = P.options[0], sName = P.options[1];
  normP(P); el.textContent = JSON.stringify(P);

  /* the size block takes the first place in the page code, the colour block keeps the first place on screen */
  var box = document.createElement('div');
  box.style.cssText = 'display:flex;flex-direction:column;gap:inherit';
  colour.parentNode.insertBefore(box, colour);
  box.appendChild(size); box.appendChild(colour);
  size.setAttribute('data-oi', '0'); colour.setAttribute('data-oi', '1');
  colour.style.order = '-1';
  var gap = getComputedStyle(colour.parentNode.parentNode).rowGap;
  if (!gap || gap === 'normal') { box.style.gap = '0'; } else box.style.gap = gap;

  /* each block gets the wording of its role */
  var lab = function (b) { return b.querySelector('.eyebrow'); };
  var cur = function (b) { var x = b.querySelector('button[aria-pressed="true"]'); return x ? x.getAttribute('data-v') : ''; };
  var sl = lab(size), cl = lab(colour);
  if (sl) sl.textContent = sName;
  if (cl) { cl.textContent = cName + ': '; var b = document.createElement('b'); b.className = 'ar-optname'; b.style.cssText = 'font-weight:500;letter-spacing:.04em'; b.textContent = cur(colour); cl.appendChild(b); }
  var printed = size.querySelector('p.note');
  Array.prototype.slice.call(colour.querySelectorAll('p.optnote, p.disc')).forEach(function (n) { size.appendChild(n); });
  if (printed) colour.appendChild(printed);
})();

/* Colour photos: when a colour is chosen, the main photo becomes the photo of that variant. */
(function () {
  var form = document.getElementById('arBuy'), main = document.getElementById('pMain'), idIn = document.getElementById('arVariant');
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!form || !main || !idIn || !m) return;
  var RE = /colou?r|design|style/i, byId = null;
  fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
    byId = {}; p.variants.forEach(function (v) { byId[v.id] = v; });
  }).catch(function () {});
  form.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.ar-opt button[data-v]') : null;
    if (!b || !byId) return;
    var lab = b.closest('.ar-opt').querySelector('.eyebrow');
    if (!lab || !RE.test(lab.textContent)) return;
    setTimeout(function () {
      var shot = document.getElementById('cShot');
      if (shot && !shot.hidden) return;
      var v = byId[idIn.value], im = v && v.featured_image;
      if (!im || !im.src) return;
      var src = im.src + (im.src.indexOf('?') < 0 ? '?' : '&') + 'width=1100';
      if (main.getAttribute('src') !== src) main.src = src;
      var file = function (u) { return (u || '').split('?')[0].split('/').pop(); }, name = file(src);
      Array.prototype.forEach.call(document.querySelectorAll('.thumb'), function (x) { x.setAttribute('aria-pressed', file(x.getAttribute('data-src')) === name ? 'true' : 'false'); });
    }, 0);
  });
})();

/* Product cards: while the pointer is on a card, its photo moves to the next photo of the product every second. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
  var cache = {}, cur = null, timer = null;
  function list(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
      return (p.images || []).map(function (u) { return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=520'; });
    }).catch(function () { return []; });
    return cache[h];
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
    if (cur) { var im = cur.querySelector('.arch img'); if (im && cur._src) im.src = cur._src; }
    cur = null;
  }
  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest ? e.target.closest('a.card[data-h]') : null;
    if (c === cur) return;
    stop();
    if (!c) return;
    var im = c.querySelector('.arch img');
    if (!im) return;
    cur = c; c._src = im.getAttribute('src');
    list(c.getAttribute('data-h')).then(function (imgs) {
      if (cur !== c || imgs.length < 2) return;
      var i = 0; new Image().src = imgs[1];
      timer = setInterval(function () {
        i = (i + 1) % imgs.length; im.src = imgs[i]; new Image().src = imgs[(i + 1) % imgs.length];
      }, 1000);
    });
  });
  document.documentElement.addEventListener('mouseleave', stop);
})();
